import { useEffect, useRef } from 'react'

type Props = {
  handleSelectedFilter: (arg: boolean) => void
}

// TODO - Refactor and rename this hook
export const useCloseFilterSection = ({ handleSelectedFilter }: Props) => {
  const filterSectionRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        filterSectionRef.current &&
        !filterSectionRef.current.contains(event.target as Node)
      ) {
        handleSelectedFilter(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [filterSectionRef])

  return { filterSectionRef }
}
